<template>
  <div class="viewport viewport-with-top-nav viewport-compact">
    <pull-refresh :on-refresh="onRefresh">
      <TopNav></TopNav>

      <div class="display-1 pt-3 mb-0">{{$t('LoanApplicationDetailsPage.title')}}</div>

      <div class="text-center my-6 py-6" v-if="application == null">
        <spinner></spinner>
      </div>
      <template v-else>
        <div class="h6 mb-3 text-muted">
          <template v-if="application.reference">
            {{ $t('LoanApplicationDetailsPage.reference', { reference: application.reference }) }}
          </template>
        </div>
        <div class="mb-5">
          <LoanApplicationTimeline :application="application" :show-future="true"></LoanApplicationTimeline>
        </div>
      </template>
    </pull-refresh>
    <div class="flex-grow-1"></div>
  </div>
</template>

<script>
import TopNav from '@shared/components/TopNav'
import store from '@shared/store'
import LoanApplicationTimeline from '@shared/components/LoanApplicationTimeline'
import PullRefresh from '@shared/components/PullRefresh'

export default {
    name: 'LoanApplicationDetailsPage',
    components: {
      LoanApplicationTimeline,
      TopNav,
      PullRefresh
    },
    data () {
      return {
        application: null,
        state: store.state
      }
    },
    methods: {
      onRefresh() {
        this.loadData()
      },
      loadData() {
        this.application = null
        this.$http.get(`/api/applications/${this.$route.params.id}`).then(response => {
          this.application = response.data
        })
      }
    },
    mounted () {
      this.loadData()
    }
  }
</script>
